var Marionette = require('backbone.marionette');
var EntitiesCollection = require('../../collections/entities-collection');
var EntityModel = require('../../models/entity-model');


var EntitiesSelectView = Marionette.View.extend({
    template: require('../../templates/entities/entities-select.html'),


    selectedEntity: new EntityModel(),
    events: {
        'change #entity': 'entitySelected'
    },

    ui: {
      selectEl: '#entity'
    },

    collectionEvents: {
        request: 'showLoading',
        sync: 'hideLoading',
        error: 'logError'
    },

    placeholder: 'Select an entity',

    templateContext: function () {
        var that = this;
        return {
            showLabel: that.showLabel,
            label: that.label,
            placeholder: that.placeholder,
            selectedEntityId: that.selectedEntity.get('id')
        }
    },

    initialize: function (options) {
        _.bindAll(this, 'onRender', 'entitySelected');
        var that = this;
        if (options) {
            that.selectedEntity.set('id', options.entityId);
            that.renderLabel = options.renderLabel == true;
            that.label = options.label;
            var params = [];
            if (options.customPlaceholder) {
                that.placeholder = options.customPlaceholder;
            }
            if (options.entityType)
                that.entityType = options.entityType;

            if (options.collectionValues) {
                that.collection = options.collectionValues;
            } else {
                if (options.entityType) {
                    that.entityType = options.entityType;
                    params.push({
                        key: 'type',
                        value: options.entityType
                    });
                }
                if(options.params){
                    params = params.concat(options.params);
                }
                that.collection = new EntitiesCollection([], {params: params});
                that.collection.fetch({success: function() {
                    if (options.filterFn && typeof options.filterFn == "function") {
                        that.collection = that.collection.filter(options.filterFn);
                    }
                    that.render();
                }});
            }

        }
    },

    onRender: function () {
        this.$('#entity').selectize({
            allowEmptyOption: false,
            inputClass: 'form-control selectize-input normal-width'
        });
    },

    entitySelected: function (event) {
        var select = $(event.target);
        var that = this;
        that.selectedEntity.set('id', event.target.value);
        that.triggerMethod('entity:selected', {
            id: event.target.value,
            name: $('option:selected', select).text(),
            type: that.entityType
        });
    },

    showLoading: function () {
        this.$('.loading').show();
    },

    hideLoading: function () {
        this.$('.loading').hide();
    },

    logError: function (obj, response) {
        this.$('.loading').hide();
        this.triggerMethod('server:error', response.responseText);
    },

    reset: function() {
        this.ui.selectEl.selectedIndex = 0;
        this.render();
    }

});

module.exports = EntitiesSelectView;


//////////////////
// WEBPACK FOOTER
// ./app/views/entities/entities-select.js
// module id = 226
// module chunks = 0